export default "__VITE_ASSET__OTYIMjux__"